module.exports = __webpack_public_path__ + "img/github.250ccd9b.svg";